import axios, { AxiosResponse } from 'axios';
import { Resiliation } from '../model/resiliation';

export interface IResiliationApi {
    postResiliation(resiliation:Resiliation): Promise<AxiosResponse<any>>;
  }

  class ResiliationApi implements IResiliationApi {

    async postResiliation(resiliation:Resiliation): Promise<AxiosResponse<any>> {

        const formData = new FormData();
       
    
        let resil = {...resiliation};
    
    
        //hack: ugly
       /* if (reclamation.relationSPB.contractSociete === '') {
          let relationSpb = {...reclamation.relationSPB};
          delete relationSpb.contractSociete;
          recla.relationSPB = {...relationSpb};
        }*/
        const informations = new Blob([JSON.stringify(resil.informations)], {
          type: 'application/json'
        });
       // formData.append("relationSPB", relationSpb);
        const contrat = new Blob([JSON.stringify(resil.contrat)], {
          type: 'application/json'
        });
        const choixResil = new Blob([JSON.stringify({ choix: resil.choixResil.choixResiliation })], {
          type: 'application/json'
        });
        const motifMaintenant = new Blob([JSON.stringify(resil.motifMaintenant)], {
          type: 'application/json'
        });

        const recaptcha = new Blob([JSON.stringify(resil.recap.recaptcha)], {
          type: 'application/json'
        });
        formData.append("informations", informations);
        formData.append("contrat", contrat);
        formData.append("motifMaintenant", motifMaintenant);
        formData.append("choixResil", choixResil);

       formData.append("recaptcha", resil.recap.recaptcha);

    
        return await axios({ 
          
          method: "post",
          url: "/api/resiliation",
          data: formData,
          headers: { "Content-Type": "multipart/form-data"}
        });
        
        
        
      }
    
    }
    
    const resiliationApi = new ResiliationApi();
    
    export { resiliationApi };